<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-xm(:title="$t('sec2')" tag="h2")
    .grid.is-widescreen-7.is-desktop-8
      .column
        p.u-text-lg {{$t('sec2Desc')}}

  section.u-mt-md.u-mb-md
    AppLink(to="/impact/volunteering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Zero plastic",
    "pageDesc":"Zero plastic is Bainaat initiative through which we are contributing to a better marine wildlife.",
    "mantra":"Zero plastic",
    "mantraDesc":"Every year, +8 million tons of plastic are thrown in the ocean. And with more than5.3 trillion pieces of plastic floating in water, marine wildlife is in danger. Through Zero plastic, we are trying to redesign the economy of plastic to be of no waste.",
    "sec1Items":{
      "1":{
        "title":"Agriculture pollution",
        "desc":"Making sure that more farmers are transforming their agriculture habits into organic and environment friendly ones."
      },
      "2":{
        "title":"Industrial pollution",
        "desc":"Factories and manufacturing waste is getting into the way of both shore and water. Through our connections with organizations that are marine driven, we hope to get more and more business owners into the circle."
      },
      "3":{
        "title":"Urban pollution",
        "desc":"Human waste is getting more dangerous than ever. Through awareness campaigns and continuous support of recycling acts, you and us could help save more marine wildlife souls."
      }
    },
    "sec2":"Actions on |ground",
    "sec2Desc":"By 2050, there will be more plastic than fish in the oceans. With our partners, we strive to reduce the damage by taking initiatives and volunteering on the ground to make a change by hand.",
    "cta":"See our  <br> volunteering acts"
  },
  "ar": {
    "pageTitle":"عالم بدون بلاستيك",
    "pageDesc":"عالم بدون بلاستيك هي مبادرة بيانات التي نساهم من خلالها في تحسين الحياة البحرية.",
    "mantra":"عالم بدون| بلاستيك",
    "mantraDesc":"كل عام يتم إلقاء 8 مليون طن من البلاستيك في المحيط. ومع وجود أكثر من 3.5 تريليون قطعة من البلاستيك تطفو في الماء، فإن الحياة البرية البحرية في خطر كبير. من خلال مبادرة عالم بدون بلاستيك، نحاول إعادة استخدام البلاستيك بحيث لا يهدر.",
    "sec1Items":{
      "1":{
        "title":"التلوث الزراعي",
        "desc":"التأكد من أن المزيد من المزارعين يعتمدون في زراعتهم على المزيد من السماد الطبيعي والموارد صديقة البيئة."
      },
      "2":{
        "title":"التلوث الصناعي",
        "desc":"تخرج المصانع النفايات الخاصة بها نحو كل من الشاطئ والماء. من خلال اتصالاتنا مع المنظمات ذات القيادة البحرية، نأمل في جذب المزيد والمزيد من أصحاب الأعمال إلى التفكير في التقليل من نفايات المصانع."
      },
      "3":{
        "title":"التلوث الحضري",
        "desc":"أصبحت النفايات البشرية أكثر خطورة من أي وقت مضى. من خلال حملات التوعية والدعم المستمر لأعمال إعادة التدوير، يمكننا المساعدة  نحن وأنت على إنقاذ المزيد من أرواح الحياة البحرية."
      }
    },
    "sec2":"الإجراءات على الأرض",
    "sec2Desc":"بحلول عام 2050، سيكون هناك بلاستيك أكثر من الأسماك في المحيطات. مع شركائنا، نسعى جاهدين للحد من الأضرار من خلال اتخاذ مبادرات والتطوع على أرض الواقع لإجراء تغيير باليد.",
    "cta":"تعرف على أعمالنا<br>  التطوعية"
  }
}
</i18n>
